import "intl";
import "intl/locale-data/jsonp/cs-CZ.js";
import "intl/locale-data/jsonp/en.js";

//import 'intl' because of IE10 support
import "intl/locale-data/jsonp/cs-CZ.js";
import "intl/locale-data/jsonp/en.js";

import React from "react";
import { createRoot } from "react-dom/client";
import { browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";

import configureStore from "./utils/store";
import AppRouter from "./AppRouter";

import "draft-js/dist/Draft.css";
import "draft-js-mention-plugin/lib/plugin.css";
import "@gov-design-system-ce/styles/html/tokens.css";
import "@gov-design-system-ce/styles/html/styles.css";
import "@gov-design-system-ce/styles/html/layout.css";
import "@gov-design-system-ce/styles/html/components.css";
import "@gov-design-system-ce/styles/html/animations.css";
import "./assets/less/gov-theme-override.css";
import "./assets/less/main.css";

// Polyfill pre onTouchTap -> onClick (Material-UI 0.x kompatibilita s React 18)
// Material-UI 0.x používa onTouchTap, ktorý vyžaduje react-tap-event-plugin
// Ten už nefunguje s React 18, preto mapujeme onTouchTap na onClick
const originalCreateElement = React.createElement;
React.createElement = function (type, props, ...children) {
  if (props && props.onTouchTap && !props.onClick) {
    props = { ...props, onClick: props.onTouchTap };
    delete props.onTouchTap;
  }
  return originalCreateElement.call(this, type, props, ...children);
};

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

// React 18 new API
const container = document.getElementById("root");
const root = createRoot(container);

root.render(<AppRouter store={store} history={history} />);
